import React, { Component, createRef } from 'react'
import './index.less'
import { inject, observer } from 'src/core/store'
import { setDocumentTitle, setUidToken, InitPage } from 'src/helper/tool'
import langM from './lang'
import { getlangV2, setlang } from 'src/helper/getlang'
import { getDateObj } from 'src/helper/time'
import { openStore } from 'src/helper/openStore'
import LoaderComp from 'src/component/LoadingComp'

@inject('store')
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.momentStore = this.props.store.register('app/moment')
  }

  state = {
    lang: langM.zh,
    isShowReminder: false,
    loadState: true,
    language: 'en'
  }

  async componentDidMount() {
    setDocumentTitle('Moment')
  }

  async componentWillMount() {
    let { language } = this.props.location.query
    console.log(this.props.location.query)
    language = await getlangV2(language, langM)
    this.setState({
      lang: setlang(language, langM),
      language: language
    })
    let uid = await setUidToken(this.props.location.query)
    await this.RunOnStart(uid)
  }

  RunOnStart = async (uid) => {
    this.setState({ uid: uid })
    let { mid } = this.props.location.query
    await this.momentStore.getData(mid)
    this.setState({
      loadState: false
    })
  }

  download = () => {
    downloadApp()
  }

  followComp = () => {
    let following_userInfo = this.momentStore.data.followingUserInfo
    return (
      <div className="moment-user-following">
        {/* {following_userInfo.duid && (
          <div className="follow-icon">
            <img src="/img/app/moment/user_icon.png" alt="" />
          </div>
        )}
        {
          following_userInfo.duid && (
            <div className="follow-txt">{following_userInfo.nickname} Following</div>
          )
        } */}
      </div>
    )
  }

  userComp = () => {
    let user = this.momentStore.data.userInfo
    return (
      <div className="moment-user-info">
        <div className="user-avatar">
          {user.avatarurl && <img src={`${user.avatarurl}`} alt="" />}
          {user.avatarurl == undefined && <div className="df" src="" alt=""></div>}
        </div>
        <div className="info-box">
          {user.nickname && <div className="username">{user.nickname}</div>}
          {user.nickname == undefined && <div className="df"></div>}
          <div className="usermedal">
            {user.gender != undefined && (
              <div className="medal-item">
                {user.gender == 1 && <img src={`/img/app/moment/sex_1.png`} alt="" />}
                {user.gender == 2 && <img src={`/img/app/moment/sex_2.png`} alt="" />}
              </div>
            )}
            {user.blueSign == 1 && (
              <div className="medal-item">
                <img src="/img/app/moment/verify.png" alt="" />
              </div>
            )}
            {user.gender == undefined && user.blueSign == undefined && <div className="df"></div>}
          </div>
        </div>
      </div>
    )
  }

  contentComp = () => {
    let content = this.momentStore.data.content
    let isExist = this.momentStore.data.obj
    console.log(isExist)
    return (
      <div className="app-moment-content">
        {content}
        {isExist == null && <div className="df"></div>}
      </div>
    )
  }

  picComp = () => {
    let imgList = this.momentStore.data.imageList
    let user = this.momentStore.data.userInfo
    let isExist = this.momentStore.data.obj
    return (
      <div
        onClick={() => {
          this.setState({ isShowReminder: true })
        }}
        className="app-moment-img-wrap"
      >
        {imgList && isExist == null && <div className="df"></div>}
        {imgList.length == 1 && (
          <div className="one-img">
            {imgList.length > 0 && imgList[0].url.indexOf('mp4') != -1 && (
              <div className="play-box">
                <img className="video-pic" src={imgList.length > 0 && imgList[0].image} />
                <div className="play"></div>
              </div>
            )}
            {imgList.length > 0 && imgList[0].url.indexOf('mp4') == -1 && (
              <img src={`${imgList.length > 0 && imgList[0].url}`} alt="" />
            )}
          </div>
        )}
        {imgList.length == 2 && (
          <div className="two-img">
            <div
              style={{ backgroundImage: `url(${imgList.length > 0 && imgList[0].url})` }}
              className="img-item-pic1"
            ></div>
            <div
              style={{ backgroundImage: `url(${imgList.length > 1 && imgList[1].url})` }}
              className="img-item-pic2"
            ></div>
          </div>
        )}
        {imgList.length == 3 && (
          <div className="three-img">
            <div
              style={{ backgroundImage: `url(${imgList.length > 0 && imgList[0].url})` }}
              className="img-item-pic1"
            ></div>
            <div className="img-item-pic2">
              <div
                style={{ backgroundImage: `url(${imgList.length > 1 && imgList[1].url})` }}
                className="img-item-pic2-1"
              ></div>
              <div
                style={{ backgroundImage: `url(${imgList.length > 2 && imgList[2].url})` }}
                className="img-item-pic2-2"
              ></div>
            </div>
          </div>
        )}
        {imgList.length == 4 && (
          <div className="four-img">
            <div className="img-item-pic1">
              <div
                style={{ backgroundImage: `url(${imgList.length > 0 && imgList[0].url})` }}
                className="img-item-pic2-1"
              ></div>
              <div
                style={{ backgroundImage: `url(${imgList.length > 1 && imgList[1].url})` }}
                className="img-item-pic2-2"
              ></div>
            </div>
            <div className="img-item-pic2">
              <div
                style={{ backgroundImage: `url(${imgList.length > 2 && imgList[2].url})` }}
                className="img-item-pic2-1"
              ></div>
              <div
                style={{ backgroundImage: `url(${imgList.length > 3 && imgList[3].url})` }}
                className="img-item-pic2-2"
              ></div>
            </div>
          </div>
        )}
      </div>
    )
  }

  timeComp = () => {
    let time = this.momentStore.data.time != 0 && this.momentStore.data.time
    let { year: y, month: m, date1: d, hour: h, minutes: min } = getDateObj(time)
    return (
      <div className="app-moment-time">
        {time != 0 && `${h}:${min} · ${y}/${m}/${d}`}
        {time == '' && <div className="df"></div>}
      </div>
    )
  }

  typeComp = () => {
    let forwardNum = this.momentStore.data.forwardNum
    let giftNum = this.momentStore.data.giftNum
    let likeNum = this.momentStore.data.likeNum
    return (
      <div className="app-moment-type">
        {this.momentStore.data.forwardNum != -1 && (
          <div className="type-wrap">
            <div className="retweet">
              <span className="num">{forwardNum}</span>
              <i>Forward</i>
            </div>
            <div className="like">
              <span className="num">{likeNum}</span>
              <i>Like</i>
            </div>
            <div className="gift">
              <span className="num">{giftNum}</span>
              <i>Gift</i>
            </div>
          </div>
        )}
        {forwardNum == -1 && <div className="df"></div>}
      </div>
    )
  }

  openAppComp = () => {
    let txt_content =
      'Using App, you can talk and make friends with people all around the world, in a simple and reliable way.'
    return (
      <div
        className="app-open-wrap"
        onClick={() => {
          openStore()
        }}
      >
        <div className="icon"></div>
        <div className="title">
          <div className="main">Yayya</div>
          <div className="second">{txt_content}</div>
        </div>
        <div className="open">Download</div>
      </div>
    )
  }

  picClickReminderComp = () => {
    return (
      <div style={{ display: `${this.state.isShowReminder ? 'flex' : 'none'}` }} className="app-moment-reminder">
        <div className="content">
          <span>
            See more interesting things?
            <br />
            Come Yayya!
          </span>
        </div>
        <div className="comfirm">
          <div
            onClick={() => {
              this.setState({ isShowReminder: false })
            }}
            className="cancle"
          >
            cancle
          </div>
          <div
            className="go"
            onClick={() => {
              openStore()
            }}
          >
            Go
            <img src="/img/icon.png" />
          </div>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className={`app-moment-wrap ${this.state.language == 'ar' ? 'app-moment-ar' : ''}`}>
        <hr className="hx" />

        <LoaderComp show={this.state.loadState} />

        {/* 关注 */}
        {this.followComp()}

        {/* 用户 */}
        {this.userComp()}

        {/* 内容 */}
        {this.contentComp()}

        {/* 图片 */}
        {this.picComp()}

        {/* 时间 */}
        {this.timeComp()}

        {/* 类型 */}
        {/* {this.typeComp()} */}

        {/* 跳转商店 */}
        {this.openAppComp()}

        {/* 图片点击弹窗 */}
        {this.picClickReminderComp()}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/moment/index.js